import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MainNavMobileService {
  open$ = new BehaviorSubject(false);
  inSearch$ = new BehaviorSubject(false);
}
